import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-3368767a"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src", "alt"];
const _hoisted_2 = { class: "property-card__badges" };
const _hoisted_3 = { class: "operation-badge" };
const _hoisted_4 = {
    key: 0,
    class: "status-badge"
};
const _hoisted_5 = {
    key: 0,
    class: "photo-count",
    "aria-label": "Cantidad de fotos"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M4 7h3l1.2-2h7.6L17 7h3v12H4V7Zm8 9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" })
], -1));
const _hoisted_7 = { class: "property-card__body" };
const _hoisted_8 = { class: "property-card__location" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z" })
], -1));
const _hoisted_10 = { class: "property-card__price" };
const _hoisted_11 = { class: "property-card__facts" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { key: 1 };
const _hoisted_14 = { key: 2 };
const _hoisted_15 = { key: 3 };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "✓", -1));
import { computed } from 'vue';
import { formatPrice, listingLabel, statusLabel } from '@/types/property';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PropertyCard',
    props: {
        property: {}
    },
    setup(__props) {
        const props = __props;
        const placeholder = new URL('@/assets/notarial-placeholder.jpg', import.meta.url).href;
        const coverImage = computed(() => props.property.photos[0]?.url || placeholder);
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("article", {
                class: _normalizeClass(["property-card", { 'property-card--unavailable': _ctx.property.status !== 'available' }])
            }, [
                _createVNode(_component_router_link, {
                    to: { name: 'property-detail', params: { slug: _ctx.property.slug } },
                    class: "property-card__image"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("img", {
                            src: coverImage.value,
                            alt: _ctx.property.photos.length ? _ctx.property.title : ''
                        }, null, 8, _hoisted_1),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(listingLabel)(_ctx.property)), 1),
                            (_ctx.property.status !== 'available')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(statusLabel)(_ctx.property.status)), 1))
                                : _createCommentVNode("", true)
                        ]),
                        (_ctx.property.photos.length > 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                _hoisted_6,
                                _createTextVNode(" " + _toDisplayString(_ctx.property.photos.length), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["to"]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createTextVNode(" " + _toDisplayString(_ctx.property.location), 1)
                    ]),
                    _createVNode(_component_router_link, {
                        to: { name: 'property-detail', params: { slug: _ctx.property.slug } }
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("h3", null, _toDisplayString(_ctx.property.title), 1)
                        ]),
                        _: 1
                    }, 8, ["to"]),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(formatPrice)(_ctx.property)), 1),
                    _createElementVNode("div", _hoisted_11, [
                        (_ctx.property.bedrooms != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.property.bedrooms), 1),
                                _createTextVNode(" dorm.")
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.property.bathrooms != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.property.bathrooms), 1),
                                _createTextVNode(" baños")
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.property.area_m2 != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.property.area_m2), 1),
                                _createTextVNode(" m²")
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.property.parking)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                _hoisted_16,
                                _createTextVNode(" garaje")
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 2));
        };
    }
});
